<template>
  <div class="game">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <div
      class="game__tournament"
      v-if="tournamentId"
      @click="
        () => {
          if (!playerColor || (match && match.result))
            $router.push({
              path: `/tournaments/${this.tournamentId}`,
            });
        }
      "
    >
      <TournamentGame
        :tournamentId="tournamentId"
        :matchId="matchId"
        :match="match"
      />
    </div>

    <!-- GAMEBOARD -->
    <GameBoardExtended
      v-if="!isLoading"
      :tournament-id="tournamentId"
      :is-finalising="isFinalising"
    >
      <GameDataManagerFirebase :matchId="matchId" />
    </GameBoardExtended>

    <GameRefereeSecondary
      :matchId="matchId"
      @onGameReady="handleGameReady"
      @onGameFinalizing="handleGameFinalizing"
      @onGameFinalized="handleGameFinalized"
      @onCancelFinalizing="handleCancelFinalizing"
    />

    <GameDevInfo :gameData="gameDataCopy"></GameDevInfo>
  </div>
</template>

<script>
import GameBoardExtended from "@/components/games/GameBoardExtended";
import GameDataManagerFirebase from "@/components/games/GameDataManagerFirebase";
import GameDevInfo from "@/components/games/GameDevInfo";
import TournamentGame from "@/components/tournaments/TournamentGame";
import GameRefereeSecondary from "@/components/games/GameRefereeSecondary";
import { mapGetters } from "vuex";
import { initFirestoreTimeOffset } from "@/services/firebase";
import gameUrls from "@/mixins/gameUrls";

export default {
  name: "Match",

  mixins: [gameUrls],

  components: {
    GameBoardExtended,
    GameDataManagerFirebase,
    GameDevInfo,
    GameRefereeSecondary,
    TournamentGame,
  },

  data() {
    return {
      isLoading: true,
      isFinalising: false,
    };
  },

  computed: {
    ...mapGetters({
      getGameDataCopyByMatchId: "getGameDataCopyByMatchId",
    }),

    gameDataCopy() {
      return this.getGameDataCopyByMatchId(this.matchId);
    },

    matchId() {
      return this.$route.params.gameId;
    },

    match() {
      return this.gameDataCopy.match;
    },

    playerColor() {
      return this.gameDataCopy.playerColor;
    },

    tournamentId() {
      return this.$route.params.tournamentId;
    },
  },

  watch: {
    match: {
      deep: true,
      handler() {
        if (!this.match) return;
        if (
          this.match.createdAt &&
          this.match.tournamentId &&
          this.$route.name !== "tournamentGameV2"
        ) {
          this.$router.replace({
            path: this.getTournamentGameUrl(
              this.match.tournamentId,
              this.match.match_id
            ),
          });
          return;
        }
        if (this.isFinalising) {
          this.isFinalising = !this.match.result;
        }
      },
    },
  },

  methods: {
    handleGameReady() {
      this.isLoading = false;
    },

    handleGameFinalizing() {
      this.isFinalising = true;
    },

    handleGameFinalized() {
      this.isFinalising = false;
    },

    handleCancelFinalizing() {
      this.isFinalising = false;
    },
  },

  created() {
    initFirestoreTimeOffset();
  },
};
</script>

<style scoped></style>
